import { render, staticRenderFns } from "./HygienistsSingle.vue?vue&type=template&id=2a094cd6&scoped=true"
import script from "./HygienistsSingle.vue?vue&type=script&lang=js"
export * from "./HygienistsSingle.vue?vue&type=script&lang=js"
import style0 from "./HygienistsSingle.vue?vue&type=style&index=0&id=2a094cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a094cd6",
  null
  
)

export default component.exports